import { render, staticRenderFns } from "./DutyStationDetail.vue?vue&type=template&id=64cd9002&"
import script from "./DutyStationDetail.vue?vue&type=script&lang=js&"
export * from "./DutyStationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports